<script setup lang="ts">
import {
  RevolugoVueCurrencyPickerBtn,
  RevolugoVueLangPickerBtn,
} from '@revolugo/elements-vue3'
</script>

<template>
  <div
    class="w-full h-12 px-2 flex justify-between items-center sticky top-0 bg-white z-50 shadow-md"
  >
    <!-- https://github.com/nuxt/nuxt/issues/13494 -->
    <!-- problem with public/ for images -->
    <img
      alt="logo"
      src="../../public/images/logo.svg"
      class="h-7"
    />

    <div class="flex gap-1">
      <RevolugoVueCurrencyPickerBtn :dialog="true" />
      <RevolugoVueLangPickerBtn :dialog="true" />
    </div>
  </div>
</template>
